__turbopack_context__.v({
  "container": "Title-module__dvnICW__container",
  "firstLetter": "Title-module__dvnICW__firstLetter",
  "letterContainer": "Title-module__dvnICW__letterContainer",
  "verticalText": "Title-module__dvnICW__verticalText",
});
